module.exports = __webpack_public_path__ + "static/img/head_logo.cbc8ddd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/head_logo.png
// module id = 0t5L
// module chunks = 104